import React from 'react'

import { createStyles, withStyles, WithStyles, Theme } from '@material-ui/core/styles'

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

interface Props {
  className?: string
}

const styles = (theme: Theme) => createStyles({
  title: {
    color: theme.palette.text.secondary,
    padding: theme.spacing(),
    fontSize: 12,
    fontWeight: theme.typography.fontWeightMedium,
    paddingLeft: theme.spacing() * 4,
    paddingRight: theme.spacing() * 4,
  },
  divider: {
    height: 1,
    borderTop: `1px dashed ${theme.palette.text.secondary}`
  }
})

type InjectedProps = Props & WithStyles<typeof styles>

const FancyDivider: React.SFC<InjectedProps> = ({ className, classes, children }) => {
  return (
    <Grid container alignItems="center" wrap="nowrap" className={className}>
      <Grid item xs className={classes.divider} />
      <Grid item>
        <Typography variant="body1" align="center" className={classes.title}>
          {children}
        </Typography>
      </Grid>
      <Grid item xs className={classes.divider} />
    </Grid>
  )
}

export default withStyles(styles)(FancyDivider)
